import apiClient from './client';

export const alternativesAPI = {
  // Получить все альтернативы проекта
  getByProject: async (projectId) => {
    const response = await apiClient.get(`/alternatives/project/${projectId}`);
    return response.data;
  },

  // Получить альтернативу по ID
  getById: async (id) => {
    const response = await apiClient.get(`/alternatives/${id}`);
    return response.data;
  },

  // Создать новую альтернативу
  create: async (alternativeData) => {
    const response = await apiClient.post('/alternatives/', alternativeData);
    return response.data;
  },

  // Обновить альтернативу
  update: async (id, updateData) => {
    const response = await apiClient.put(`/alternatives/${id}`, updateData);
    return response.data;
  },

  // Удалить альтернативу
  delete: async (id) => {
    const response = await apiClient.delete(`/alternatives/${id}`);
    return response.data;
  },
};
